import React, { SVGProps } from "react";

export default function SupDepositIn(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M10.6319 11.3797V3.58679H9.63191V11.6431L7.87886 9.89009L7.17175 10.5972L9.99979 13.426L12.8282 10.5976L12.1211 9.89048L10.6319 11.3797Z" fill="currentColor" />
      <path
        d="M10.0002 14.4256L9.29268 13.7189L8.61329 13.0387C8.27413 13.3971 8.06613 13.8809 8.06613 14.4133C8.06613 15.5178 8.96156 16.4133 10.0661 16.4133C11.1707 16.4133 12.0661 15.5178 12.0661 14.4133C12.0661 13.8473 11.8311 13.3363 11.4533 12.9725L10.0002 14.4256Z"
        fill="currentColor"
      />
    </svg>
  );
}
